function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowRiskMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.681,
    height: 57.482,
    viewBox: "0 0 66.681 57.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41",
    d: "M18.449 148.787a21.047 21.047 0 0 1 0-29.781l-8.679-8.68a33.319 33.319 0 0 0 0 47.142 1.954 1.954 0 0 0 2.758 0l5.917-5.917a1.954 1.954 0 0 0 0-2.758z",
    transform: "translate(0 -100.555)",
    style: {
      fill: "#00d200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42",
    d: "M118.334 45.081a33.319 33.319 0 0 0-47.141 0 1.954 1.954 0 0 0 0 2.758l5.92 5.918a1.954 1.954 0 0 0 2.758 0 21.047 21.047 0 0 1 29.781 0 1.953 1.953 0 0 0 2.758 0l5.917-5.917a1.954 1.954 0 0 0 0-2.758z",
    transform: "translate(-61.426 -35.311)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "M279.571 45.081A33.121 33.121 0 0 0 256 35.311v12.276a20.921 20.921 0 0 1 14.891 6.169 1.953 1.953 0 0 0 2.758 0l5.917-5.917a1.954 1.954 0 0 0 0-2.758z",
    transform: "translate(-222.66 -35.311)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "M366.516 148.787a21.047 21.047 0 0 0 0-29.781l8.679-8.68a33.319 33.319 0 0 1 0 47.142 1.954 1.954 0 0 1-2.758 0l-5.917-5.917a1.954 1.954 0 0 1 0-2.758z",
    transform: "translate(-318.286 -100.555)",
    style: {
      fill: "#ff1e5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45",
    d: "M12.276 133.891a20.922 20.922 0 0 1 6.173-14.886l-8.679-8.68A33.118 33.118 0 0 0 0 133.9z",
    transform: "translate(0 -100.555)",
    style: {
      fill: "#00d200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "M366.517 306.173a20.944 20.944 0 0 0 6.173-14.894h12.277a33.117 33.117 0 0 1-9.77 23.571 1.954 1.954 0 0 1-2.758 0l-5.917-5.917a1.954 1.954 0 0 1-.005-2.759z",
    transform: "translate(-318.286 -257.943)",
    style: {
      fill: "#ff1e5a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47",
    d: "M22.569 1.8a6.145 6.145 0 0 0-8.681 0C10.864 4.819 1.378 19.678.3 21.363A1.954 1.954 0 0 0 3 24.06c1.686-1.071 16.55-10.56 19.569-13.578a6.145 6.145 0 0 0 0-8.681z",
    transform: "rotate(63.99 -2.151 32.56)",
    style: {
      fill: "#003c50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48",
    d: "M22 0 0 22a1.954 1.954 0 0 0 2.43.266C4.115 21.192 18.978 11.7 22 8.686A6.145 6.145 0 0 0 22 0z",
    transform: "rotate(63.99 -3.874 32.12)",
    style: {
      fill: "#001428"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRiskMeter);
export default __webpack_public_path__ + "static/media/low_risk_meter.b450efa42c11a209bd4e9bfdabc55d21.svg";
export { ForwardRef as ReactComponent };